import { Inject, Injectable, Injector }from '@angular/core';

import { FootprintEdi_DatasourceService } from './FootprintEdi.datasource.index';

import { app_ds_get_projects_by_project_and_ownerService } from './app.datasource.index';

@Injectable({ providedIn: 'root' })
export class app_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.FootprintEdi = this.injector.get(FootprintEdi_DatasourceService);
  }

    public FootprintEdi: FootprintEdi_DatasourceService;
  public app: app_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _ds_get_projects_by_project_and_owner: app_ds_get_projects_by_project_and_ownerService;
  public get ds_get_projects_by_project_and_owner(): app_ds_get_projects_by_project_and_ownerService {
    if(!this._ds_get_projects_by_project_and_owner) {
      this._ds_get_projects_by_project_and_owner = this.injector.get(app_ds_get_projects_by_project_and_ownerService);
    }
    return this._ds_get_projects_by_project_and_owner;
  }
}

